export default ngModule =>
{
    ngModule.controller('ComparatorStep4Ctrl',
        function (response, ZohoService, application, AonConfig, $interpolate, CorporateService, $sce) {
            this.corporateConfig = AonConfig.corporate;
            const status = response.status;
            const responseData = response.data;

            // Set up available variables
            const { is_operator, success_page_script } = AonConfig.corporate;
            this.showCorporateSuccessPageScript = is_operator && success_page_script;
            this.application = application;

            // An application can be successful and still be pending (if the fund does not support
            // straight through processing for example)
            this.was_successful = status === 200;
            this.reference_number = responseData.customer_id || responseData.internal_reference;
            this.is_pending = _.get(responseData, 'pending', false);
            this.transaction_id = _.get(responseData, 'transaction_id', false);
            this.success_html = $sce.trustAsHtml($interpolate(this.corporateConfig.success_page_message)(this));
            this.failure_html = $interpolate(this.corporateConfig.failure_page_message)(this);

            if (is_operator) {
                this.submitCorporateScriptResponses = () => {
                    this.isSavingResponses = true;
                    this.savedScriptResponseError = false;
                    this.savedCorporateScriptResponse = false;
                    const postData = _.cloneDeep(this.application.corporate_script_responses);
                    return CorporateService.saveCorporateScriptResponse(
                        responseData.internal_reference,
                        postData
                    ).then(() => {
                        this.isSavingResponses = false;
                        this.savedCorporateScriptResponse = true;
                    }).catch(() => {
                        this.isSavingResponses = false;
                        this.savedScriptResponseError = true;
                    });
                }
            }
        }
    );
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step4-ctrl.js